"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .controller(
    "colorrequestEditCtrl",
    function (
      $scope,
      $rootScope,
      $state,
      $filter,
      $localStorage,
      apiSettings,
      Chat,
      MessageService,
      tools,
      ColorRequest,
      Customer,
      Alerts,
      WorkflowApproval,
      Internal,
      maxAllowedFileSize,
      classificationsTypes,
      projectsTypes,
      customers,
      designers,
      segments,
      model,
      settings,
      attachmentTypes,
      workflowApprovals,
      reproveReasons,
      salesList,
      Attachment,
      $timeout,
      holidays,
      $location,
      $anchorScroll,
      $stateParams,
      enumerators,
      $uibModal,
      Status
    ) {
      var vm = this;
      vm.settings = settings;

      vm.enumerators = enumerators;

      vm.isControleQualidade = function () { return vm.settings.isColorsUserGroupByName('ControleQualidade'); };


      var $translate = $filter("translate");


      angular.extend($scope.$parent.vm, {
        title: "colorsRequests.settings.title",
        insertUrl: null,
      });

      vm.projectModule = config.projectModule;

      vm.isChatOpened = false;
      vm.userId = $localStorage.userId;
      $scope.uploader = {};

      // INICIALIZAÇÕES
      $rootScope.laddaLoading = false;
      vm.reproveReasons = reproveReasons;

      vm.isRegionalManager = function () {
        return vm.isGerenteRegiona();
      };


      vm.model = model;
      vm.oldModel = {
        ...vm.model,
      };

      if (vm.model.colorsRequestId) {
        Chat.connect($localStorage.userId, vm.model.colorsRequestId);
        vm.customerTypeIdSelected = vm.model.customersTypeId;
      }

      if (vm.model.dueDate) {
        vm.model.dueDate = new Date(vm.model.dueDate);
        vm.model.dueDate.setHours(12, 0, 0);
      }

      if (vm.model.expectedDate) {
        vm.model.expectedDate = new Date(vm.model.expectedDate);
        vm.model.expectedDate.setHours(12, 0, 0);
      } else {
        vm.model.expectedDate = null;
      }

      vm.msgProjectAttachHasChanged = null;
      vm.workflowApprovals = workflowApprovals;
      // Pega a última aprovação para saber pra onde vai solicitação, para frente ou para trás.
      vm.lastWorkflowApproval =
        vm.workflowApprovals.rows[vm.workflowApprovals.rows.length - 1];

      vm.attachment = {}; // Inicializa a model que armazena as informações de um novo anexo
      vm.attachmentEditing = {}; // Inicializa a model que armazena as informações do anexo que está sendo editado
      vm.attachmentsDesign = attachmentTypes.filter(
        (x) => x.attachmentTypeId == window.enumerators.attachmentType.Design
      )[0].attachments;
      vm.attachmentsProject =
        attachmentTypes.filter(
          (x) => x.attachmentTypeId == window.enumerators.attachmentType.Project
        ).length > 0
          ? attachmentTypes.filter(
            (x) => x.attachmentTypeId == window.enumerators.attachmentType.Project
          )[0].attachments
          : [];
      vm.attachmentsInvoiceSaleList =
        attachmentTypes.filter(
          (x) => x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
        ).length > 0
          ? attachmentTypes.filter(
            (x) =>
              x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
          )[0].attachments
          : [];

      vm.attachments = [];
      vm.chatImage = {};
      vm.isAttaching = false;
      vm.isReprove = false;
      vm.isReproveReasons = false;
      vm.isInsertSale = false;
      vm.showSales = true;
      vm.addClassErrorPhotoProject = false;
      vm.addClassErrorPhotoDesign = false;
      vm.addClassErrorInvoiceSale = false;
      vm.sale = {
        valueTintingProducts: 0,
        valueOthersProducts: 0,
        colorsProducts: [],
        othersProducts: [],
      };
      // CONFIGURAÇÃO DO UPLOAD
      vm.attachmentsInvoiceSale = [];
      vm.countAttachmentsDesign = vm.attachmentsDesign.length;
      vm.countAttachmentsProject = vm.attachmentsProject.length;
      vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;

      vm.tempFolder = tools.getRandomString(8);
      vm.uploadConfig = {
        singleFile: true,
        testChunks: false,
        target:
          apiSettings.baseUri +
          "v1/internal/upload" +
          "?tempFolder=" +
          vm.tempFolder,
        headers: {
          Authorization: "Bearer " + $localStorage.authorizationData.token,
        },
      };
      vm.uploadImageConfig = {
        singleFile: true,
        testChunks: false,
        target:
          apiSettings.baseUri +
          "v1/chat/upload-image/" +
          vm.model.colorsRequestId,
        headers: {
          Authorization: "Bearer " + $localStorage.authorizationData.token,
        },
      };
      vm.allowedFileExtensions = [];
      vm.maxAllowedFileSiz = 0;
      vm.classificationsType = classificationsTypes;
      vm.projectsType = projectsTypes;
      vm.customers = customers;
      vm.segments = segments;
      vm.designers = designers;

      vm.createNotificationAlert = function (dateInput, timeInput) {
        const date = new Date(dateInput);

        const timeParts = timeInput.split(':');
        const hours = parseInt(timeParts[0], 10);
        const minutes = parseInt(timeParts[1], 10);

        date.setHours(hours);
        date.setMinutes(minutes);

        const timezoneOffset = date.getTimezoneOffset();
        const offsetHours = Math.floor(Math.abs(timezoneOffset) / 60);
        const offsetMinutes = Math.abs(timezoneOffset) % 60;

        const offsetSign = timezoneOffset > 0 ? '-' : '+';
        const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, '0')}:${String(offsetMinutes).padStart(2, '0')}`;

        const localISOString = date.toISOString().slice(0, -1);

        const formattedDate = `${localISOString}${formattedOffset}`;


        vm.pushNotification('PersonalColorRequest', formattedDate, true)
      }

      vm.pushNotification = function (alertType, date, showAlert) {
        Alerts.insertNew(
          { enumAlertType: alertType },
          {
            "alertType": alertType,
            "alertData": vm.model,
            "alertDate": date,
            "alertTargetKey": vm.model.colorsRequestId,
            "projectModule": vm.projectModule
          },
          function (response) {
            if (showAlert) {
              MessageService.alertInfo(
                "Lembrete criado com sucesso!"
              );
            }

            Alerts.updateCount();
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      }



      if (vm.model.customerId && vm.customers && vm.customers.length) {
        vm.selectedCustomer = vm.customers.find(function (item) {
          return item.key == vm.model.customerId;
        })
        vm.model.customerId = null;
      }

      // AUTOCOMPLETE DE Cliente
      vm.getCustomer = function (val) {
        return Customer.listIds({ keyword: val }).$promise;
      };

      // AUTOCOMPLETE DE CORES
      vm.getColors = function (val) {
        return Internal.colorsList({ pageSize: 50, keyword: val }).$promise;
      };

      //AUTOCOMPLETE INSERT
      vm.insertText = function (item) {
        if (!vm.model.features) {
          vm.model.features = item.code + ' - ' + item.name;
        } else {
          vm.model.features += '\n' + item.code + ' - ' + item.name;
        }

        vm.color = "";
      };

      vm.delColor = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.model.colors.splice(index, 1);
      };

      vm.editAttachment = function (item, enumAttachmentType) {
        vm.showAttachmentForm(true, enumAttachmentType);

        vm.attachmentEditing = item; //Guarda a referência do item que está sendo editado numa variável global, para que a mesma seja atualizada no caso do usuário clicar no botão salvar
        angular.copy(vm.attachmentEditing, vm.attachment); //Atualiza a model de anexo com um cópia do objeto que está sendo editado

        vm.attachment.isEditing = true;
      };

      vm.deleteAttachment = function (item, enumAttachmentType) {
        switch (enumAttachmentType) {
          case window.enumerators.attachmentType.Design:
            vm.countAttachmentsDesign -= 1;
            break;
          case window.enumerators.attachmentType.Project:
            vm.countAttachmentsProject -= 1;
            break;
          case window.enumerators.attachmentType.InvoiceSale:
            vm.countAttachmentsInvoiceSale -= 1;
            break;
          default:
            break;
        }
        item.isDeleted = true;
        item.requiredDbUpdate = true;
      };

      vm.showAttachmentForm = function (visible, enumAttachmentType) {
        vm.isAttaching = visible;
        vm.attachType = enumAttachmentType;

        switch (enumAttachmentType) {
          case window.enumerators.attachmentType.Design:
            vm.allowedFileExtensions = ["jpeg", "png", "jpg"];
            vm.maxAllowedFileSize = 5242880;
            break;
          case window.enumerators.attachmentType.Project:
            vm.allowedFileExtensions = ["pdf"];
            vm.maxAllowedFileSize = parseInt(maxAllowedFileSize.value);
            break;
          case window.enumerators.attachmentType.InvoiceSale:
            vm.allowedFileExtensions = ["pdf", "jpeg", "png", "jpg"];
            vm.maxAllowedFileSize = parseInt(maxAllowedFileSize.value);
            break;
          default:
            break;
        }

        vm.attachment = {
          attachmentId: 0,
          attachmentTypeId: enumAttachmentType,
          isDeleted: false,
          isEditing: false,
          requiredDbUpdate: true,
        };

        // Reseta o formulário caso esteja fechando a modal de inclusão do anexo
        if (visible == false) vm.resetAttachmentForm();
      };

      vm.resetAttachmentForm = function () {
        var form = $scope.colorrequestAttachmentForm;
        form.$setPristine();
        form.$setUntouched();
      };

      vm.saveAttachment = function (enumAttachmentType) {
        $rootScope.laddaLoading = true;

        vm.attachment.requiredDbUpdate = true;

        // Verifica se é uma inclusão ou edição do objeto
        if (vm.attachment.isEditing == true) {
          angular.copy(vm.attachment, vm.attachmentEditing); // Repassa as atualizações feitas na model do anexo, para o objeto de referência (anexo que está sendo editado)
          switch (enumAttachmentType) {
            case window.enumerators.attachmentType.Project:
              vm.msgProjectAttachHasChanged =
                "Para enviar o projeto para aprovação confirme clicando no botão Salvar";
              if (vm.deleteOrEditProjectAttachCQ()) {
                vm.msgProjectAttachHasChanged =
                  "Para prosseguir com a ATUALIZAÇÃO do projeto confirme clicando no botão Salvar";
              }
              break;
            default:
              break;
          }
        } else {
          vm.attachments.push(vm.attachment); // Inclui o novo objeto no array

          switch (enumAttachmentType) {
            case window.enumerators.attachmentType.Design:
              vm.countAttachmentsDesign += 1;
              vm.attachmentsDesign.push(vm.attachment);
              vm.addClassErrorPhotoDesign = false;
              break;
            case window.enumerators.attachmentType.Project:
              vm.countAttachmentsProject += 1;
              vm.attachmentsProject.push(vm.attachment);
              vm.addClassErrorPhotoProject = false;
              vm.msgProjectAttachHasChanged =
                "Para enviar o projeto para aprovação confirme clicando no botão Salvar";
              if (vm.deleteOrEditProjectAttachCQ()) {
                vm.msgProjectAttachHasChanged =
                  "Para prosseguir com a INCLUSÃO do projeto confirme clicando no botão Salvar";
              }
              break;
            case window.enumerators.attachmentType.InvoiceSale:
              vm.countAttachmentsInvoiceSale += 1;
              vm.attachmentsInvoiceSale.push(vm.attachment);
              vm.addClassErrorInvoiceSale = false;
              break;
            default:
              break;
          }
        }

        vm.showAttachmentForm(false, 0);
        $rootScope.laddaLoading = false;
      };

      vm.uploadSubmit = function ($files, $event, $flow) {
        if ($files[0] === undefined) return;

        // Valida se a extensão do arquivo é permitida
        if (
          tools.validateFileExtension(
            $files[0].name,
            vm.allowedFileExtensions
          ) == false
        )
          return;

        // Valida o tamanho do arquivo
        if (
          tools.validateFileMaxSize($files[0].size, vm.maxAllowedFileSize) ==
          false
        )
          return;

        $flow.upload();
      };

      vm.uploadSuccess = function ($file, $message, $flow) {
        var uploadResult = JSON.parse($message);
        vm.attachment.name = uploadResult.originalFilename;
        vm.attachment.fileDocument = uploadResult.filename;
        vm.attachment.url = tools.getFileTempPath(
          vm.tempFolder,
          uploadResult.filename
        );

        // Reseta o flow
        $flow.cancel();
      };

      vm.getallowedFileExtensions = function (enumAttachmentType) {
        return "." + vm.allowedFileExtensions.join(", .");
      };

      vm.getFileExtension = function (filename) {
        return tools.getFileExtension(filename);
      };

      vm.selectCustomer = function () {
        if (!vm.model.customerId) {
          return;
        }

        ColorRequest.verifyCustomer(
          { customerId: vm.model.customerId },
          function (response) {
            // if (response.error60) {
            //     MessageService.alertInfo("Há projetos para esta loja com mais de 60 dias em aberto.");
            //     $state.go('main.colorrequest', {
            //         expired: true
            //     });
            //     return;
            // }

            if (response.error120) {
              MessageService.alertInfo(
                "Há projetos para esta loja com mais de 120 dias em aberto"
              );
              $state.go("main.colorrequest", {
                expired: true,
              });
              return;
            }

            // Se Loja Comercial e Bonificação for false devo verificar designer por uf.
            if (
              response.errorDesigner &&
              !vm.model.isBonusAccounts
            ) {
              MessageService.alertInfo(
                "Não há Designer para UF da loja selecionada."
              );
              $state.go("main.colorrequest");
              return;
            }

            vm.customerTypeIdSelected = response.customersTypeId;
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.isNewRequest = function () {
        return (
          vm.model.colorsRequestId === undefined ||
          vm.model.colorsRequestId == 0
        );
      };

      vm.getWorkflowApprovalParameter = function (enumStatusApproval) {
        return {
          colorsRequestId: vm.model.colorsRequestId,
          enumStatusApproval: enumStatusApproval,
          comment: vm.model.comment,
          disapprovalReasonId: vm.disapprovalReasonId
            ? vm.disapprovalReasonId
            : null,
        };
      };

      vm.save = function (loading) {
        if (
          vm.attachmentsDesign.length == 0 ||
          (vm.attachmentsDesign.filter((x) => x.isDeleted == true).length > 0 &&
            vm.attachmentsDesign.filter((x) => x.isDeleted == false).length ==
            0)
        ) {
          MessageService.alertInfo("Pelo menos uma foto é obrigatória.");
          return;
        }

        if (vm.model.isStrategicAccounts == null) {
          MessageService.alertInfo("Você deve definir se este é um projeto estratégico ou não.");
          return;
        }

        vm.model.isStrategicAccounts

        if (loading) {
          $rootScope.laddaLoading = true;
        } else {
          $rootScope.laddaLoading = false;
        }

        vm.model.attachments = vm.attachments;
        vm.model.tempFolder = vm.tempFolder;

        if (vm.selectedCustomer) {
          vm.model.customerId = vm.selectedCustomer.key;
        }

        if (!vm.model.customerId) {
          MessageService.alertInfo("É necessário escolher uma loja!");
          $rootScope.laddaLoading = false;
          return;
        }

        if (vm.isNewRequest()) {
          vm.model.workflowApprovalNext = vm.getWorkflowApprovalParameter(0);
        }

        if (vm.isNewRequest()) {
          ColorRequest.insert(
            vm.model,
            function (response) {
              if (response.fiveOrMore) {
                MessageService.alertInfo(
                  "O projeto foi para a lista de espera, pois ultrapassou o limite de projetos no mês."
                );
              }
              $state.go("main.colorrequest");
            },
            function (response) {
              MessageService.alertError(response.data);
            }
          );
        } else {
          // VALIDANDO SE TEM ARQUIVO NO CAMPO ANEXO DO PROJETO (FEITO PELO DESIGNER) PARA SABER SE EXIBE A MSG QUE TROCA DE STATUS OU SÓ ATUALIZA OS CAMPOS
          if (vm.validateIfPassStatusOrSave()) {
            vm.model.workflowApprovalNext = null;
            if (!vm.expectedDateIsValid()) {
              MessageService.alertInfo("Data prevista inválida.");
              $rootScope.laddaLoading = false;
              return;
            } else {
              vm.model.expectedDate.setHours(12, 0, 0);
              var attachments = [];
              attachments.push(...vm.attachmentsDesign);
              if (vm.attachmentsProject && vm.attachmentsProject.length > 0) {
                attachments.push(...vm.attachmentsProject);
              }

              if (!vm.projectExists() && vm.statusNeedProject()) {
                MessageService.alertInfo("Projeto obrigatório");
                $rootScope.laddaLoading = false;
                return;
              }

              vm.model.attachments = attachments;
              ColorRequest.insert(
                vm.model,
                function () {
                  $state.go("main.colorrequest");
                },
                function (response) {
                  MessageService.alertError(response.data);
                }
              );
              return;
            }
          }

          // DESIGNER ATUALIZA O ARQUIVO DO PROJETO E AVANÇA NO FLUXO
          vm.changeStatusAttachProject();
        }
      };

      vm.expectedDateIsValid = function () {
        if (
          !vm.model.expectedDate ||
          vm.model.expectedDate == null ||
          vm.model.expectedDate == "undefined" ||
          new Date(vm.model.expectedDate) < new Date()
        ) {
          return vm.isControleQualidade();
        }

        return true;
      };

      vm.statusNeedProject = function () {
        if (
          vm.lastWorkflowApproval && (
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoSolicitante ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoAnaliseSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado12 ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaConsumidor ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoAprovado ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ConcluidoVenda ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ConcluidoSemVenda ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado22
          )) {
          return true;
        }
        return false;
      };

      vm.projectExists = function () {
        if (
          !vm.attachmentsProject ||
          vm.attachmentsProject.length == 0 ||
          (vm.attachmentsProject.filter((x) => x.isDeleted == true).length >
            0 &&
            vm.attachmentsProject.filter((x) => x.isDeleted == false).length ==
            0)
        ) {
          return false;
        }
        return true;
      };

      vm.validateIfPassStatusOrSave = function () {
        if (
          vm.attachmentsProject.length == 0 ||
          (vm.attachmentsProject.filter((x) => x.isDeleted == true).length >
            0 &&
            vm.attachmentsProject.filter((x) => x.isDeleted == false).length ==
            0) ||
          (vm.model.dueDate !== vm.oldModel.dueDate && vm.enableDueDate())
        ) {
          return true;
        }
        return false;
      };

      vm.changeStatusAttachProject = function () {
        var message = `Deseja mesmo realizar a ação e mudar o status para ${vm.lastWorkflowApproval.statusNameNext} ?`;
        MessageService.confirm(
          function () {
            var params = vm.getWorkflowApprovalParameter(
              window.enumerators.statusApproval.Aprovado
            );
            vm.model.workflowApprovalNext = params;
            vm.model.attachments = vm.attachmentsProject;
            ColorRequest.insert(
              vm.model,
              function () {
                $state.go("main.colorrequest");
              },
              function (response) {
                MessageService.alertError(response.data);
              }
            );
          },
          "Confirmação",
          message
        );
        $rootScope.laddaLoading = false;
      };

      vm.changeStatus = function (type, commentRequired = false) {
        var message = "";
        switch (type) {
          case "next":
            vm.enumStatusApproval = window.enumerators.statusApproval.Aprovado;
            message = `Deseja mesmo realizar a ação e mudar o status para ${vm.lastWorkflowApproval.statusNameNext} ?`;

            if (vm.lastWorkflowApproval.statusNameNext === "Projeto Aprovado") {
              message = `${message} Após Aprovar não será mais possível solicitar alterações. Lembre-se de validar o projeto com o seu cliente.`;
            }
            break;
          case "previousMsg":
            vm.enumStatusApproval = window.enumerators.statusApproval.Reprovado;
            message = `Deseja mesmo realizar a ação e mudar o status para ${vm.lastWorkflowApproval.statusNamePrevious} ?`;

            if (
              vm.lastWorkflowApproval.statusNamePrevious ===
              "Revisão Solicitada Consumidor"
            ) {
              message = `${message} Lembre-se: só é permitido solicitar uma única revisão. Analise e confirme as informações antes de dar continuidade a esta solicitação de revisão.`;
            }
            break;
          default:
            break;
        }

        if (
          commentRequired &&
          (vm.model.comment == undefined || vm.model.comment == "")
        ) {
          MessageService.alertInfo("Comentário é obrigatório.");
          return false;
        }

        MessageService.confirm(
          function () {
            var params = vm.getWorkflowApprovalParameter(vm.enumStatusApproval);

            WorkflowApproval.updateColor(
              params,
              function () {
                $state.go("main.colorrequest");
                vm.isReprove = false;
                vm.isReproveReasons = false;
              },
              function (response) {
                MessageService.alertError(response.data);
              }
            );
          },
          "Confirmação",
          message
        );
      };

      vm.finishProject = function () {
        // Quando encerrar, se não houver venda, deve mandar para o status Concluído/Sem Venda, se tiver manda para Concluído/Venda.
        if (vm.salesListHasLength()) {
          vm.changeStatus("next");
        } else {
          if (!vm.reproveReasons || !vm.reproveReasons.length) {
            vm.reproveReasons = [];
          }

          // Só mostra motivos de encerrar projeto sem venda.
          vm.reproveReasons = vm.reproveReasons.filter(
            (x) =>
              x.disapprovalReasonTypeId ==
              vm.enumerators.disapprovalReasonsTypes.SemVenda
          );
          vm.othersReason = vm.reproveReasons.find(
            (x) =>
              x.disapprovalReasonTypeId ==
              vm.enumerators.disapprovalReasonsTypes.SemVenda &&
              x.value == "Outros"
          );
          vm.isReproveReasons = true;
        }
      };

      vm.approveReprove = function (type) {
        switch (type) {
          case 1:
            vm.changeStatus("next");
            break;
          case 2:
            if (
              settings.permissions.includes("ApproveReproveSwRequest") &&
              vm.lastWorkflowApproval && vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.AguardandoAnaliseSW
            ) {
              // Revisão SW Apenas descreve.
              vm.isReprove = true;
            } else {
              if (!vm.reproveReasons || !vm.reproveReasons.length) {
                vm.reproveReasons = [];
              }

              // Se reprovar e for o Solicitante precisa selecionar os motivos (lista) de reprovação.
              // Só mostra motivos de recusa do Solicitante/Consumidor
              vm.reproveReasons = vm.reproveReasons.filter(
                (x) =>
                  x.disapprovalReasonTypeId ==
                  vm.enumerators.disapprovalReasonsTypes.Consumidor
              );
              vm.othersReason = vm.reproveReasons.find(
                (x) =>
                  x.disapprovalReasonTypeId ==
                  vm.enumerators.disapprovalReasonsTypes.Consumidor &&
                  x.value == "Outros"
              );
              vm.isReproveReasons = true;
            }
            break;
          default:
            break;
        }
      };

      /*
      Funções de Sales
      */
      // #region Sales

      vm.noColorProductId = false;

      vm.insertSale = function () {
        if (
          vm.sale.valueOthersProducts == 0 &&
          vm.sale.valueTintingProducts == 0
        ) {
          MessageService.alertInfo(
            "Valor em produtos Tintométricos ou Valor em demais produtos deve ser preenchido."
          );
          return;
        }

        if (
          vm.attachmentsInvoiceSale.filter((x) => x.isDeleted == 0).length == 0
        ) {
          MessageService.alertInfo("Nota fiscal obrigatório");
          return;
        }
        vm.sale.tempFolder = vm.tempFolder;
        vm.sale.attachmentsInvoiceSale = vm.attachmentsInvoiceSale;
        vm.sale.colorsRequestId = vm.model.colorsRequestId;

        ColorRequest.insertSale(
          vm.sale,
          function (response) {
            vm.getAttachsAndSales();
            vm.cancelInsertSale();
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.cancelInsertSale = function () {
        vm.sale = {
          valueTintingProducts: 0,
          valueOthersProducts: 0,
          colorsProducts: [],
          othersProducts: [],
        };
        vm.attachmentsInvoiceSale = [];
        vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;
        vm.isInsertSale = false;
      };

      vm.getTintingProducts = function (val) {
        vm.autoCompleteProducts = Internal.colorsProductsList({ pageSize: 50, keyword: val })
          .$promise;
        return vm.autoCompleteProducts;
      };

      vm.getOthersProducts = function (val) {
        return Internal.othersProductsList({ pageSize: 50, keyword: val })
          .$promise;
      };

      $scope.$watch("vm.colorProduct", function (newValue, oldValue) {
        if (newValue) {
          var exist = false;
          vm.noColorProductId = false;

          if (!vm.sale.colorsProducts) {
            vm.sale.colorsProducts = [];
          }

          if (newValue.colorsProductId) {
            vm.sale.colorsProducts.map((x) => {
              if (newValue.colorsProductId == x.colorsProductId) {
                exist = true;
              }
            });
          } else {
            vm.noColorProductId = true;
          }

          if (!exist && newValue.colorsProductId) {
            vm.sale.colorsProducts.push(newValue);
            vm.colorProduct = null;
          }
        }
      });

      $scope.$watch("vm.salesProductColor", function (newValue, oldValue) {
        if (vm.colorProduct && newValue) {
          var exist = false;
          vm.noColorProductId = false;

          vm.colorProduct.colorId = newValue.colorId;
          vm.colorProduct.code = newValue.code;
          vm.colorProduct.colorName = newValue.name;
          vm.colorProduct.rgb = newValue.rgb;

          vm.colorProduct.description = `${vm.colorProduct.code}' '${vm.colorProduct.colorName} - ${vm.colorProduct.productName}`;

          if (!vm.sale.colorsProducts) {
            vm.sale.colorsProducts = [];
          }

          vm.sale.colorsProducts.map((x) => {
            if (vm.colorProduct.colorId == x.colorId && vm.colorProduct.productId == x.productId) {
              exist = true;
            }
          });

          if (!exist) {
            vm.sale.colorsProducts.push(vm.colorProduct);
          }

          vm.colorProduct = null;
          vm.salesProductColor = null;
        }
      });

      $scope.$watch("vm.otherProduct", function (newValue, oldValue) {
        if (newValue) {
          var exist = false;

          if (!vm.sale.othersProducts) {
            vm.sale.othersProducts = [];
          }
          vm.sale.othersProducts.map((x) => {
            if (newValue.othersProductId == x.othersProductId) {
              exist = true;
            }
          });

          if (!exist) {
            vm.sale.othersProducts.push(newValue);
          }

          vm.otherProduct = null;
        }
      });

      vm.delColorProduct = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.sale.colorsProducts.splice(index, 1);
      };

      vm.delOtherProduct = function (x) {
        var index = vm.model.colors.indexOf(x);
        vm.sale.othersProducts.splice(index, 1);
      };

      vm.editSale = function (saleId) {
        ColorRequest.saleGet(
          { saleId: saleId },
          function (response) {
            vm.sale = response;
            vm.isInsertSale = true;
            vm.attachmentsInvoiceSaleList.map((x) => {
              if (x.saleId == vm.sale.saleId) {
                vm.attachmentsInvoiceSale.push(x);
              }
            });
            vm.countAttachmentsInvoiceSale = vm.attachmentsInvoiceSale.length;
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.deleteSale = function (saleId) {
        MessageService.confirm(
          function () {
            ColorRequest.deleteSale(
              { saleId: saleId },
              function () {
                vm.getAttachsAndSales();
              },
              function (response) {
                MessageService.alertError(response.data);
              }
            );
          },
          "Confirmação",
          "Deseja mesmo excluir essa venda?"
        );
      };

      vm.getAttachsAndSales = function () {
        Attachment.list(
          { promotionRequestId: vm.model.colorsRequestId },
          function (response) {
            vm.attachmentsInvoiceSaleList =
              response.filter(
                (x) =>
                  x.attachmentTypeId == window.enumerators.attachmentType.InvoiceSale
              ).length > 0
                ? response.filter(
                  (x) =>
                    x.attachmentTypeId ==
                    window.enumerators.attachmentType.InvoiceSale
                )[0].attachments
                : [];
            vm.getSales();
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.selectedReason = '';
      vm.customReason = '';
      vm.comment = '';

      vm.openModal = function (id) {
        vm.reproveSaleId = id;
        $('#approvalModal').modal('show');
      };

      vm.submitApproval = function (attachId, status) {
        var comment = vm.comment;

        var params = {
          comment: comment,
          enumStatusApproval: status
        };

        Attachment.salesApproval({ id: attachId }, params, function (response) {
          vm.comment = '';
          vm.reproveSaleId = '';
          vm.salesList.map(x => {
            if (x.attachmentId == attachId) {
              x.status = status
            }
          })
          vm.pushNotification('ColorSalesAttachmentApproval', new Date().toISOString(), false)
          $('#approvalModal').modal('hide');

          if (!vm.hasPendingApprovals()) {
            MessageService.confirm(
              function () {
                vm.finishProject();
              },
              "Projeto Completo",
              "Não há mais vendas pendentes de aprovação. Deseja encerrar o projeto agora?"
            );
          }
        }, function (response) {
          MessageService.alertError(response.data);
        });
      };

      vm.hasPendingApprovals = function () {
        if (!vm.salesList) return false;
        return vm.salesList.some(function (item) {
          return vm.showApprovalAttachButtons(item);
        });
      };

      vm.updateComment = function () {
        if (vm.selectedReason === 'Outro') {
          vm.comment = vm.customReason;
        } else {
          vm.comment = vm.selectedReason;
        }
      };

      vm.getSales = function () {
        ColorRequest.listSales(
          { colorsRequestId: vm.model.colorsRequestId },
          function (response) {
            vm.formSalesList(response);
          },
          function (response) {
            MessageService.alertError(response.data);
          }
        );
      };

      vm.formSalesList = function (response) {
        vm.salesList = response.saleList;
        const totalSale = {
          createdOn: "Valor total",
          valueTintingProducts: response.saleTotal.sumValueTintingProducts,
          valueOthersProducts: response.saleTotal.sumValueOthersProducts,
        };


        vm.salesList.push(totalSale);
        if (vm.salesList) {
          if (!vm.attachmentsInvoiceSaleList || !vm.attachmentsInvoiceSaleList.length) {
            vm.attachmentsInvoiceSaleList = [];
          }

          vm.salesList.map((x) => {
            const attach = vm.attachmentsInvoiceSaleList.find(
              (y) => y.saleId == x.saleId
            );
            if (attach) {
              x.url = attach.url;
              x.fileDocument = attach.fileDocument;
              x.attachmentId = attach.attachmentId,
                x.status = attach.enumStatusApproval;
            }
            return x;
          });

        }
      };

      vm.formSalesList(salesList);

      vm.salesListHasLength = function () {
        // Necessário para remover a última linha que exibe a soma de todas as notas.
        const onlySales = vm.salesList.filter((x) => x.saleId != null);
        if (onlySales.length == 0) {
          return false;
        }
        return true;
      };

      // #ndregion

      vm.isBusinessDay = function (date) {
        var isBuDay = true;
        if (date.getDay() == 0 || date.getDay() == 6) {
          isBuDay = false;
        }

        if (holidays && holidays.length) {
          holidays.forEach((x) => {
            var dateToCompare = new Date(x.date + "T12:00:00");

            if (date.getTime() === dateToCompare.getTime()) {
              isBuDay = false;
            }
          });
        }

        return isBuDay;
      };

      vm.setExpectedDate = function () {
        if (vm.isNewRequest()) {
          var expectedDate = new Date();
          expectedDate.setHours(12, 0, 0);

          var countDays = 0;
          var countUtilDays = 3;

          for (var index = 0; index < countUtilDays; index++) {
            expectedDate.setDate(expectedDate.getDate() + 1);
            if (!vm.isBusinessDay(expectedDate)) {
              countDays++;
            }
          }

          expectedDate.setDate(expectedDate.getDate() + countDays);
          vm.model.expectedDate = expectedDate;
        }
      };

      vm.setExpectedDate();

      vm.transformName = function (name) {
        if (name && name.length > 40) {
          return name.substr(0, 40) + "...";
        } else {
          return name || "";
        }
      };

      vm.showProjectAttachment = function () {
        if (vm.isNewRequest()) {
          return false;
        }

        // Mostra o projeto caso for Controle de Qualidade nesses status
        if (vm.deleteOrEditProjectAttachCQ()) {
          return true;
        }

        if (
          vm.attachmentsProject.length == 0 &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.EmProducao
        ) {
          return false;
        }

        // Vendedor só pode ver projeto nos status abaixo
        if (
          settings.permissions.includes("ApproveReproveSaleRequest") &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoVerificado12 &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoVerificado22 &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoAprovado &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ConcluidoVenda &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ConcluidoSemVenda
        ) {
          return false;
        }

        // Só mostra o projeto se status for diferente de em espera e aguardando início da produção (Designer ou SW)
        if (
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.EmEspera &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.AguardandoIniciodeProducao
        ) {
          return true;
        }

        return false;
      };

      vm.deleteOrEditProjectAttachDesigner = function () {
        // Edita o projeto se tiver em Produção e for Designer
        if (
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId ==
          vm.enumerators.statusColor.EmProducao &&
          settings.permissions.includes("InsertProjectAttach") // task do designer
        ) {
          return true;
        }

        return false;
      };

      vm.deleteOrEditProjectAttachCQ = function () {
        // Edita o projeto se tiver no status abaixo e for Controle de Qualidade
        if (
          vm.model.colorsRequestId &&
          settings.permissions.includes("ChangeProjectAttach") && // task do controle de qualidade
          vm.lastWorkflowApproval &&
          (vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.EmEspera ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoIniciodeProducao ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.EmProducao ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoSolicitante ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoAnaliseSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado12 ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaConsumidor)
        ) {
          return true;
        }

        return false;
      };

      vm.showApprovalAttachButtons = function (attach) {
        if (settings.permissions.includes("ChangeProjectAttach") && attach.attachmentId && attach.status == 'Pendente') {
          return true;
        }
        return false;
      }

      vm.showInsertButtonProjectAttachment = function () {
        // Só pode inserir attachment no projeto se não tiver nenhum anexo e for Designer
        if (
          vm.countAttachmentsProject == 0 &&
          (settings.permissions.includes("InsertProjectAttach") || // task do designer
            settings.permissions.includes("ChangeProjectAttach")) // task do controle de qualidade
        ) {
          return true;
        }
        return false;
      };

      vm.disabledChangeExpectedDate = function () {
        // Pode alterar data prevista quando tiver em produção ou aguardando início, e for designer
        if (
          vm.isControleQualidade() || (

            (settings.permissions.includes("EditColorsRequests") &&
              vm.lastWorkflowApproval &&
              (vm.lastWorkflowApproval.statusId ==
                vm.enumerators.statusColor.EmProducao ||
                vm.lastWorkflowApproval.statusId ==
                vm.enumerators.statusColor.AguardandoIniciodeProducao)) ||
            // Pode editar também nessas condições, então se retonar true, disabled fica false
            vm.editSaveColorRequest()
          )
        ) {
          return false;
        }
        return true;
      };

      vm.sendCommentPreviousStatus = function () {
        // Só pode mandar comentário (reprovar) se não estiver nesses status
        if (
          vm.model.isRequiredToApproval &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.EmProducao &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoVerificado12 &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoVerificado22 &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ProjetoAprovado &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ConcluidoVenda &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.ConcluidoSemVenda &&
          vm.lastWorkflowApproval.statusId !=
          vm.enumerators.statusColor.AguardandoAnaliseSW
        ) {
          return true;
        }
        return false;
      };

      vm.showButtonInsertSale = function () {
        /* Só pode mostrar o botão para inserir venda se for vendedor, for projeto aprovado ou
        verificado 2/2, e não pode ter finishedOn, pois quando aprova a última vez para encerrar
        fica com finishedOn na ultima aprovação, que pode ser uma das duas (aprovado ou 2/2). */
        if (
          vm.model.colorsRequestId &&
          settings.permissions.includes("InsertSale") &&
          vm.lastWorkflowApproval &&
          (vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoAprovado ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado12 ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado22) &&
          !vm.lastWorkflowApproval.finishedOn
        ) {
          return true;
        }
        return false;
      };

      vm.showSaveButton = function () {
        /* Pode salvar quando for Designer nos status de Aguardando Prod ou Em produção 
        p/ subir projeto ou quando for novo projeto (vendedor) */
        if (
          (settings.permissions.includes("EditColorsRequests") &&
            vm.model.isRequiredToApproval &&
            vm.lastWorkflowApproval &&
            (vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.EmProducao ||
              vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.AguardandoIniciodeProducao)) ||
          vm.isNewRequest() ||
          // É possível também editar o projeto nessas condições
          vm.editSaveColorRequest() ||
          vm.enableDueDate()
        ) {
          return true;
        }
        return false;
      };

      vm.showInitProductionButton = function () {
        // Designer só pode iniciar a produção nesses status abaixo
        if (
          settings.permissions.includes("EditColorsRequests") &&
          vm.model.isRequiredToApproval &&
          vm.lastWorkflowApproval &&
          (vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoIniciodeProducao ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaConsumidor)
        ) {
          return true;
        }
        return false;
      };

      vm.showFinishProjectButton = function () {
        // Vendedor só pode encerrar projeto nos status abaixo
        if (
          settings.permissions.includes("FinishColorRequest") &&
          vm.model.isRequiredToApproval &&
          vm.lastWorkflowApproval &&
          (vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoAprovado ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.ProjetoVerificado22)
        ) {
          return true;
        }
        return false;
      };

      vm.showApproveReproveButton = function () {
        // Só pode verificar/reprovar projeto quando for SW Qualidade no status AguardandoAnaliseSW
        // ou Solicitante no status ProjetoVerificado12
        if (
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          ((vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoAnaliseSW &&
            settings.permissions.includes("ApproveReproveSwRequest")) ||
            (vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.ProjetoVerificado12 &&
              settings.permissions.includes("ApproveReproveSaleRequest")))
        ) {
          return true;
        }
        return false;
      };

      vm.showApproveButton = true;
      vm.getLabelApproveButton = function () {
        // Se for SW Qualidade no status AguardandoAnaliseSW - botão: Verificar
        // Se Solicitante no status ProjetoVerificado12 - botão: Aprovar
        if (
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId ==
          vm.enumerators.statusColor.AguardandoAnaliseSW &&
          settings.permissions.includes("ApproveReproveSwRequest")
        ) {
          return "VERIFICAR";
        } else if (
          !vm.model.status?.isCompleted &&
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId ==
          vm.enumerators.statusColor.ProjetoVerificado12 &&
          settings.permissions.includes("ApproveReproveSaleRequest")
        ) {
          return "ENCERRAR PROJETO";
        } else {
          vm.showApproveButton = false;
          return "";
        }
      };

      vm.pendingRequestAction = function () {
        if (vm.model.isRequiredToApproval && vm.model.status.statusId !== vm.enumerators.statusColor.ConcluidoSemVenda && vm.model.status.statusId !== vm.enumerators.statusColor.ConcluidoVenda) {
          return true
        }
        return false;
      }

      vm.showReproveButton = true;
      vm.getLabelReproveButton = function () {
        // Se for SW Qualidade no status AguardandoAnaliseSW - botão: Reprovar
        // Se Solicitante no status ProjetoVerificado12 - botão: Solicitar Revisão
        if (
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          !vm.model.status?.isCompleted &&
          vm.lastWorkflowApproval.statusId ==
          vm.enumerators.statusColor.AguardandoAnaliseSW &&
          settings.permissions.includes("ApproveReproveSwRequest")
        ) {
          return "REPROVAR";
        } else if (
          vm.model.colorsRequestId &&
          vm.lastWorkflowApproval &&
          vm.lastWorkflowApproval.statusId ==
          vm.enumerators.statusColor.ProjetoVerificado12 &&
          settings.permissions.includes("ApproveReproveSaleRequest") &&
          !vm.salesListHasLength()
        ) {
          return "SOLICITAR REVISÃO";
        } else {
          vm.showReproveButton = false;
          return "";
        }
      };

      vm.showListDesigners = function () {
        /* Pode trocar designer quando for Controle de Qualidade nos status de Aguardando Ini. Prod. ou Em Espera */
        if (
          vm.model.colorsRequestId &&
          settings.permissions.includes("ChangeDesigner") &&
          vm.lastWorkflowApproval &&
          (vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.EmEspera ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.AguardandoIniciodeProducao ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.EmProducao ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaSW ||
            vm.lastWorkflowApproval.statusId ==
            vm.enumerators.statusColor.RevisaoSolicitadaConsumidor)
        ) {
          return true;
        }
        return false;
      };

      vm.enableDueDate = function () {
        return (vm.model.colorsRequestId && vm.isControleQualidade());
      };

      vm.editSaveColorRequest = function () {
        /* Pode editar/deletar projeto quando for Controle de Qualidade ou Vendedor nos status de Aguardando Ini. Prod. ou Em Espera */
        // Pode alterar (criar) também quando for novo
        if (
          !vm.model.colorsRequestId ||
          (vm.model.colorsRequestId &&
            settings.permissions.includes("DeleteEditColorRequest") &&
            vm.lastWorkflowApproval &&
            (vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.EmEspera ||
              vm.lastWorkflowApproval.statusId ==
              vm.enumerators.statusColor.AguardandoIniciodeProducao))
        ) {
          return true;
        }
        return false;
      };

      vm.showBonusFields = function () {
        // Não mostra os campos de Loja Comercial e Bonificação caso a loja selecionada for Revenda
        if (
          vm.model.customerId &&
          vm.customerTypeIdSelected &&
          vm.customerTypeIdSelected == vm.enumerators.customersTypes.Revenda
        ) {
          vm.model.isBonusAccounts = false;
          return false;
        }
        return true;
      };

      //Chat

      vm.toggleChat = function () {
        vm.isChatOpened = !vm.isChatOpened;
        if (vm.isChatOpened) {
          Chat.markAllAsRead($localStorage.userId, vm.model.colorsRequestId);
          vm.model.unreadMessages = 0;
          $timeout(function () {
            vm.scrollChatToBottom();
          }, 200);
        }
      };

      $scope.$on("userOnLine", function (e, chatEvent) {
        vm.model.chatMessages = chatEvent.payload.messages;
        $timeout(function () {
          vm.scrollChatToBottom();
        }, 200);
      });

      $scope.$on("receiveNotification", function (event, payload) { });

      $scope.$on("newMessage", function (e, { chatEvent, payload }) {
        vm.model.chatMessages = payload.messages;

        if (
          vm.model.chatMessages[vm.model.chatMessages.length - 1]
            .ColorsRequestId !== vm.model.colorsRequestId
        ) {
          return;
        }

        $timeout(function () {
          vm.scrollChatToBottom();
        }, 200);

        if (vm.isChatOpened) {
          Chat.markAllAsRead($localStorage.userId, vm.model.colorsRequestId);
          vm.model.unreadMessages = 0;
        } else {
          vm.model.unreadMessages = vm.model.unreadMessages + 1;
        }

        if (
          vm.model.chatMessages[vm.model.chatMessages.length - 1].UserId !==
          $localStorage.userId
        ) {
          var audio = new Audio("../sounds/exquisite.mp3");
          audio.play();
        }
      });

      vm.initChat = $stateParams.chat;
      vm.autoChatStarted = false;
      $scope.$on("chatStarted", function (e) {
        if (vm.initChat) {
          vm.autoChatStarted = true;
          $timeout(function () {
            vm.toggleChat();
          }, 200);
        }
      });

      vm.sendMessage = function () {
        if (vm.chatMessage) {
          Chat.sendMessage(
            $localStorage.userId,
            vm.model.colorsRequestId,
            vm.chatMessage
          );
          vm.chatMessage = "";
        } else if (vm.chatImage.url) {
          Chat.sendImageMessage(
            $localStorage.userId,
            vm.model.colorsRequestId,
            vm.chatImage.url
          );
          vm.chatImage = {};
        }
      };

      vm.scrollChatToBottom = function () {
        $location.hash("anchorChat");
        $anchorScroll();
      };

      vm.uploadImageSubmit = function ($files, $event, $flow) {
        if ($files[0] === undefined) return;

        // Valida se a extensão do arquivo é permitida
        if (
          tools.validateFileExtension($files[0].name, ["jpeg", "png", "jpg"]) ==
          false
        )
          return;

        // Valida o tamanho do arquivo
        if (tools.validateFileMaxSize($files[0].size, 5242880) == false) return;

        //change file name
        var splitFileName = $files[0].name.split(".");
        splitFileName[0] = vm.ramdomName();
        $files[0].name = splitFileName[0] + "." + splitFileName[1];

        $flow.upload();
      };

      vm.uploadImageSuccess = function ($file, $message, $flow) {
        var uploadResult = JSON.parse($message);
        vm.chatImage.name = uploadResult.originalFilename;
        vm.chatImage.fileDocument = uploadResult.filename;
        vm.chatImage.folder = uploadResult.tempFolder;
        vm.chatImage.url = tools.getFileChatPath(
          vm.chatImage.folder,
          uploadResult.filename
        );
        // Reseta o flow
        $flow.cancel();

        vm.sendMessage();
      };

      vm.ramdomName = function () {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
          (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
          ).toString(16)
        );
      };

      $scope.$on("$destroy", function () {
        if (vm.model.colorsRequestId) {
          Chat.exitChat($localStorage.userId, vm.model.colorsRequestId);
        }
      });

      $scope.$watch("vm.selectedCustomer", function (newValue, oldValue) {
        if (newValue && newValue.key && (!oldValue || newValue.key !== oldValue.key)) {
          Customer.get(
            { id: newValue.key },
            function (response) {
              if (!response.hasColorSample) {
                if (response.hasColorSampleLastAskedOn && !(response.hasColorSampleLastAskedOn instanceof Date)) {
                  response.hasColorSampleLastAskedOn = new Date(response.hasColorSampleLastAskedOn);
                  if (isNaN(response.hasColorSampleLastAskedOn.getTime())) {
                    return;
                  }

                  response.hasColorSampleLastAskedOn.setMonth(response.hasColorSampleLastAskedOn.getMonth() + 1);
                }

                var currentDate = new Date();

                if (!response.hasColorSampleLastAskedOn || currentDate.getTime() >= response.hasColorSampleLastAskedOn.getTime()) {
                  MessageService.confirm(
                    function () {
                      var data = {
                        customerId: vm.selectedCustomer.key,
                        hasColorSample: true
                      }
                      Customer.updateHasColorSample(data);
                    },
                    "Amostra de cores",
                    "<img src='/images/color-sample.png' alt='Color Sample' /> Esta loja já possui a amostra de cores - A Sua Cor?"
                  );
                }
              }
            }
          );
        }
      });

      $timeout(function () {
        if (!vm.autoChatStarted && vm.initChat) {
          vm.toggleChat();
        }
      }, 1200);

      vm.openChangeStatusModal = function () {
        Status.listIds({ moduleId: window.enumerators.modules.Cores }, function (data) {
          vm.statuses = data;
          vm.selectedStatus = null;
          vm.comment = '';
          $('#changeStatusModal').modal('show');
        });
      };

      vm.submitStatusChange = function () {
        if (!vm.selectedStatus || !vm.selectedStatus.key) {
          MessageService.alertInfo("Selecione um status.");
          return;
        }

        if (!vm.comment) {
          MessageService.alertInfo("O comentário é obrigatório.");
          return;
        }

        var params = {
          colorsRequestId: vm.model.colorsRequestId,
          enumStatusApproval: window.enumerators.statusApproval.Aprovado,
          statusId: vm.selectedStatus.key,
          comment: vm.comment
        };

        WorkflowApproval.updateColor(params, function () {
          $('#changeStatusModal').modal('hide');
          $state.reload();
        }, function (response) {
          MessageService.alertError(response.data);
        });
      };
    }
  );
